import type { GetResult } from '@fingerprintjs/fingerprintjs'
import * as FingerprintJS from '@fingerprintjs/fingerprintjs'

import { logger } from '@twisto/utils'

export type FingerPrintJSPromiseResponseType = GetResult | null
// we store the promise in a variable so that we can reuse it
// and not call FingerprintJS.load() multiple times
let resultPromise: Promise<FingerPrintJSPromiseResponseType> | null = null

const initFingerprintJS = () => {
  resultPromise = (async () => {
    try {
      // We recommend to call `load` at application startup.
      const fp = await FingerprintJS.load()

      // The FingerprintJS agent is ready.
      // Get a visitor identifier when you'd like to.
      const fpData = await fp.get().catch((error) => {
        logger.logError('FingerprintJS Pro error', {
          error,
        })

        return null
      })

      return fpData
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      logger.logError(error.message, {
        error,
      })

      return null
    }
  })()
}

export const getFingerprintJSPromise = async () => {
  if (resultPromise === null) {
    initFingerprintJS()
  }

  return resultPromise
}
